import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiClock, FiCheck, FiAlertTriangle, FiTrendingUp } = FiIcons;

const MetricsCards = () => {
  // Mock data - replace with real data from your backend
  const metrics = [
    {
      title: 'Today\'s Medicines',
      value: '8',
      subtitle: '3 remaining',
      icon: FiClock,
      color: 'blue',
      trend: '+2 from yesterday'
    },
    {
      title: 'Taken This Week',
      value: '42',
      subtitle: 'out of 45',
      icon: FiCheck,
      color: 'green',
      trend: '93% adherence rate'
    },
    {
      title: 'Missed Doses',
      value: '3',
      subtitle: 'this week',
      icon: FiAlertTriangle,
      color: 'red',
      trend: '-1 from last week'
    },
    {
      title: 'Streak',
      value: '12',
      subtitle: 'days',
      icon: FiTrendingUp,
      color: 'purple',
      trend: 'Personal best!'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'from-blue-500 to-blue-600 text-blue-600 bg-blue-50',
      green: 'from-green-500 to-green-600 text-green-600 bg-green-50',
      red: 'from-red-500 to-red-600 text-red-600 bg-red-50',
      purple: 'from-purple-500 to-purple-600 text-purple-600 bg-purple-50'
    };
    return colors[color];
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <motion.div
          key={metric.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          whileHover={{ y: -5 }}
          className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl bg-gradient-to-r ${getColorClasses(metric.color).split(' ')[0]} ${getColorClasses(metric.color).split(' ')[1]} flex items-center justify-center`}>
              <SafeIcon icon={metric.icon} className="text-white text-xl" />
            </div>
            <div className={`px-3 py-1 rounded-full text-xs font-medium ${getColorClasses(metric.color).split(' ').slice(2).join(' ')}`}>
              {metric.trend}
            </div>
          </div>
          
          <div className="space-y-1">
            <h3 className="text-sm font-medium text-gray-600">{metric.title}</h3>
            <div className="flex items-baseline space-x-2">
              <span className="text-3xl font-bold text-gray-900">{metric.value}</span>
              <span className="text-sm text-gray-500">{metric.subtitle}</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default MetricsCards;